/**
 * @author sshu
 * @time 2020.07.01
 * @name 无需服务端获取的微应用
 */
const noAuthApps = [
    {
        'name': 'module-outside',
        'title': '外部项目',
        'route_prefix': 'outside',
        'json':'{"devUrl":"//localhost:6600","testUrl":"/module-outside/","preUrl":"//preoutsideconsole.iclass30.com","prodUrl":"/module-outside/"}'
    }
];

export default noAuthApps;